export enum VipVerificationReason {
  Upgrade = 1,
  Downgrade = 2,
  Adjustment = 3,
}
